import { render } from "./inpatient_timeline.vue?vue&type=template&id=1622c66a&scoped=true"
import script from "./inpatient_timeline.vue?vue&type=script&lang=js"
export * from "./inpatient_timeline.vue?vue&type=script&lang=js"

import "./inpatient_timeline.vue?vue&type=style&index=0&id=1622c66a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1622c66a"]])

export default __exports__